export function setCookie(cname, cvalue, expTimeStamp) {
  let cookie = cname + "=" + cvalue;
  if (expTimeStamp) cookie += `; expires=${new Date(expTimeStamp * 1000)}`;
  cookie += `; secure`;

  document.cookie = cookie;
}

export function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
